import { extendTheme } from "@chakra-ui/react";
import { createBreakpoints } from "@chakra-ui/theme-tools";

const Input = {
  variants: {
    outline: ({ colorMode }: { colorMode: string }) => ({
      field: {
        borderColor: "gray.300",
        _hover: {
          borderColor: "gray.400",
        },
        _autofill: {
          border: `1px solid ${colorMode === "light" ? "gray.300" : "#FFFFFF"}`,
          textFillColor: `${colorMode === "light" ? "gray.700" : "#FFFFFF"}`,
          boxShadow: `0 0 0px 1000px ${
            colorMode === "light" ? "#FFFFFF" : "#1E293B"
          } inset`,
        },
      },
    }),
  },
};

const Select = {
  variants: {
    outline: {
      field: {
        borderColor: "gray.300",
        _hover: {
          borderColor: "gray.400",
        },
      },
    },
  },
};

const Checkbox = {
  baseStyle: {
    control: {
      borderColor: "gray.300",

      _hover: {
        borderColor: "gray.400",
      },
    },
  },
};

const FormLabel = {
  baseStyle: {
    fontSize: "xs",
    letterSpacing: "0.25px",
  },
};

const FormError = {
  baseStyle: {
    text: {
      fontSize: "xs",
      letterSpacing: "0.25px",
    },
  },
};

const Form = {
  baseStyle: {
    helperText: {
      fontSize: "xs",
      letterSpacing: "0.25px",
    },
  },
};

const Button = {
  baseStyle: {
    fontWeight: "500",
    lineHeight: "normal",
  },

  variants: {
    link: ({ colorMode }: { colorMode: string }) => ({
      color: colorMode === "light" ? "brand.500" : "white",
      _hover: {
        color: colorMode === "light" ? "brand.400" : "white",
      },
    }),
    brand: {
      bg: "brand.400",
      color: "white",
      fontSize: "sm",
      borderColor: "brand.500",
      _hover: {
        bg: "brand.300",
        _disabled: {
          bg: "brand:400",
          opacity: 0.4,
        },
      },
      _active: {
        bg: "brand.300",
      },
    },
  },
};

const Table = {
  baseStyle: ({ colorMode }: { colorMode: string }) => ({
    th: {
      bg: colorMode === "light" ? "#F9FAFB" : "#334155",
    },
  }),
};

const breakpoints = createBreakpoints({
  sm: "30em",
  md: "48em",
  lg: "61em",
  xl: "80.05em",
  "2xl": "96em",
});

const theme = extendTheme({
  initialColorMode: "light",
  useSystemColorMode: true,
  fonts: {
    heading: "'Roboto', sans-serif",
    body: "'Roboto', sans-serif",
  },
  colors: {
    brand: {
      50: "#C8E6FE",
      100: "#7abef5",
      200: "#0165B6",
      300: "#0269BB",
      400: "#015498",
      500: "#01457C",
    },
    darkMode: {
      100: "#0F3457",
      200: "#1E293B",
      300: "#0F172A",
    },
    lightMode: {
      100: "#FFFFFF",
      200: "#EDF2F7",
      300: "#eeeff2",
    },
  },
  breakpoints,
  components: {
    Button,
    Table,
    FormLabel,
    FormError,
    Form,
    Input,
    Checkbox,
    Select,
  },
});

export default theme;
